
  
  export default function somenteTexto(texto) {
    return texto.replace(/['"]/g, '');
  }
  

  